<app-infobox [pointData]="pointData" [penetration]="penetration"></app-infobox>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/fatturato-carta-indicator/fatturato-carta-indicator.component.html